export const mergedDate = (datePartValue, timePartValue) => {
  const datePart = new Date(datePartValue); // Thu Dec 18 2025 00:00:00 ...
  const timePart = new Date(timePartValue);
  const mergedDate = new Date(
    datePart.getFullYear(),
    datePart.getMonth(),
    datePart.getDate(),
    timePart.getHours(),
    timePart.getMinutes(),
    timePart.getSeconds(),
    timePart.getMilliseconds(),
  );
  return mergedDate;
};

export const getDateFromISO = (isoString) => {
  if (!isoString) return null;
  return new Date(isoString); // tworzy obiekt Date z całej daty, TimePicker pokaże godzinę
};

export const formatPrice = (value) =>
  Number(value ?? 0)
    .toFixed(2)
    .replace(".", ",");

export const formatClientAddress = (client) =>
  [
    client?.city,
    client?.street && `ul. ${client.street}`,
    client?.houseNumber,
    client?.apartmentNumber && `/${client.apartmentNumber}`,
  ]
    .filter(Boolean)
    .join(" ");
